export default "__VITE_ASSET__5xkk2_ha__"